@import "~/styles/v1/_variables.scss";
@import "~/styles/v1/_spacing.scss";

.FlyoverGroup {
  border-bottom: $border-standard;
  margin-bottom: $size-XS;

  &:last-child {
    &:first-child,
    &:not(:first-of-type) {
      border-bottom: 0;
    }
  }

  .Header {
    padding: 7.5px 12px;
  }
}
